"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordRequiredCharacterType = exports.PASSWORD_REQUIRED_CHARACTER_TYPE = exports.PASSWORD_HASH_PROPERTY_INPUT_TYPE = void 0;
var backend_1 = require("../../backend");
Object.defineProperty(exports, "PasswordRequiredCharacterType", { enumerable: true, get: function () { return backend_1.PasswordRequiredCharacterType; } });
exports.PASSWORD_HASH_PROPERTY_INPUT_TYPE = {
    text: 'text',
};
exports.PASSWORD_REQUIRED_CHARACTER_TYPE = {
    number: 'number',
    symbol: 'symbol',
    upperCase: 'upperCase',
    lowerCase: 'lowerCase',
};
